/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-editor-tab/redaction-list/redaction-list.component.scss */
.icon {
  --fa-primary-color: rgb(159 168 218 / 86%);
  --fa-secondary-color: #3c4eb6;
  --fa-secondary-opacity: 1 ;
}
.icon-alternate {
  color: rgb(36, 62, 144);
}
.edit {
  border-bottom: 1px solid rgba(113, 125, 192, 0.8);
}
.selected-edit {
  background: rgba(197, 202, 233, 0.3607843137);
}
.expander {
  background-color: #E4E4E4;
  color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #f8f7f5;
  --fa-secondary-color: #8f8e87da;
  --fa-secondary-opacity: 1 ;
}
:host-context(.dark-theme) .icon-alternate {
  color: inherit;
}
:host-context(.dark-theme) .edit {
  border-bottom: 1px solid #5B5B5B;
}
:host-context(.dark-theme) .selected-edit {
  background: rgba(255, 255, 255, 0.0784313725);
}
:host-context(.dark-theme) input {
  border: 1px solid rgba(255, 255, 255, 0.1882352941);
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
:host-context(.dark-theme) input:focus {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
input {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border: 1px solid #243e90;
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
input:focus {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border-color: #283593;
  box-shadow: 0 0 3px rgba(40, 52, 147, 0.6862745098);
}
/*# sourceMappingURL=redaction-list.component.css.map */
